<template>
  <div>
    <autoLogout />

    <loader :loader="loader" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)" 
      

      class="mt-2 ml-4 mr-4 calendar">
        <v-card-text>
          <v-row align="baseline" justify="center" class="mb-2">
            <branch-offices-list :classOfDiv="cols"
             style="padding-top: 22px" v-on:triggerChange="branchOfficeSelected"
             :model="idBranchOfficeSelected"
             />
            <v-col cols="12" md="3" xl="3" sm="12">
              <vc-date-picker color="green" v-model="range" is-range :max-date="new Date()" class="pb-0">
                <template v-slot="{ inputEvents }">
                  <div class="d-flex justify-center align-center">
                    <v-text-field v-on="inputEvents.start" :value="rangeComputed" label="Seleccione fecha"
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'" @click:append="clearCalendar"
                      :disabled-input="validData"></v-text-field>
                  </div>
                </template>
              </vc-date-picker>
            </v-col>
            <v-col>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details />
            </v-col>
          </v-row>

          <v-data-table :headers="headers" :items="listConsPend" :search="search" :items-per-page="10" dense
            :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
            no-data-text="Sin resultados disponibles" fixed-header height="auto">
            <!-- <template v-slot:[`item.idPatient`]="{ item }">
              {{item}}
            </template> -->

            <template v-slot:[`item.actions`]="{ item, index }">
              <v-tooltip top  v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION_ATTEND)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="getDataConsulty(item.idConsulta)" small>
                    <v-icon v-bind="attrs" v-on="on" color="secondary">
                      mdi-doctor
                    </v-icon>
                  </v-btn>
                </template>
                <span>Atender</span>
              </v-tooltip>
              <v-tooltip top :index="index"  v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION_CANCEL)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="checkCancel(item)" color="error" small>
                    <v-icon v-bind="attrs" v-on="on"> mdi-stop </v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>
            </template>



            

            <!-- <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION_ATTEND)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="getDataConsulty(item.idConsulta)">
                    <v-icon color="secondary" v-bind="attrs" v-on="on">
                      mdi-doctor
                    </v-icon>
                  </v-btn>
                </template>
                <span>Atender</span>
              </v-tooltip>
              <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONSULTATION_CANCEL)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="checkCancel(item)" :disabled="loader">
                    <v-icon color="error" v-bind="attrs" v-on="on">
                      mdi-stop
                    </v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>
            </template> -->



          </v-data-table>
        </v-card-text>
      </v-card>
      <!-- v-slot="{ handleSubmit }" -->
      <encabezado :elementos="titleAttend" v-if="showAction(2)" />
      <v-card v-if="showAction(2)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form lazy-validation @submit.prevent="saveConsultation">
            <!-- handleSubmit(saveConsultation) -->
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">
                      Información de consulta
                    </h3>
                  </v-col>
                  <v-col md="2">
                    <h3 class="font-weight-black mb-5">
                      Id Consulta:
                      <span class="error--text">{{
      dataPatient.idMedicalPractice
    }}</span>
                    </h3>
                  </v-col>
                </v-row>

                <v-row justify="space-around" v-if="flagComponentInfo">
                  <!-- <v-col>
                    <div class="row">
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="dataPatient.fullName"
                          label="Nombre del paciente*"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="dataPatient.curp"
                          label="CURP*"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="genderPatient"
                          label="Sexo*"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="old"
                          label="Edad*"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-col> -->
                  <v-col cols="12" md="12" sm="12">
                    <patient-information :model="infoPatient" @patientLoaded="onPatientLoaded"/>
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <Patient-consultation-info :model="infoPatient" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="text-center">
                    <v-btn class="secondary" @click="showAppointments(1)" v-if="!noMoreAppointments" ref="button">
                      Ver consultas previas
                      <v-icon right>mdi-account-convert</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-expansion-panels class="my-3" v-model="panelSV">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Signos vitales
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <div class="col-md-4" v-for="(input, index) in inputsVitalSign" :key="index">
                              <validation-provider v-slot="{ errors }" :rules="checkTypetoAssignValidation(input)"
                                :name="input.label">
                                <v-text-field v-model="vitalSign[index].description" :label="input.label"
                                  :suffix="input.suffix" :required="input.required" :type="input.type" dense
                                  :error-messages="errors" min="0" @change="
      panelDis = false;
    calculateIMC();
    "></v-text-field>
                              </validation-provider>
                            </div>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    
                    <v-expansion-panels v-if="vitalSignLoaded" class="mt-5 mb-10" v-model="panelCalculators">
  <v-expansion-panel
    v-for="(calculator, index) in filteredCalculators"
    :key="index"
  >
    <v-expansion-panel-header>
      <v-row dense class="text-left">
        <v-col cols="12" sm="12" md="12">
          <v-banner
            color="blue-grey lighten-5"
            class="br black--text"
            shaped
            single-line
            dense
            align="left"
          >
            <v-icon class="mr-2">mdi-chart-donut</v-icon>
            {{ calculator.name }}
          </v-banner>
        </v-col>
      </v-row>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-container>
        <v-row>
          <!-- Aquí están las preguntas -->
          <v-col
            v-for="(question, qIndex) in calculator.dataQuestions"
            :key="qIndex"
            cols="12"
          >
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: question.required }"
              :name="question.name"
            >
              <v-autocomplete
                v-if="question.typeAnswer === 2"
                v-model="question.answerClosed"
                :items="question.answers"
                item-value="idAnswer"
                item-text="name"
                :label="question.name"
                color="#59805c"
                clearable
                dense
                :error-messages="errors"
              >
                <template v-slot:selection="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }}
                </template>
              </v-autocomplete>
              <v-text-field
                v-else-if="question.typeAnswer === 1"
                v-model="question.answerOpen"
                :label="question.name"
                dense
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>

          <!-- ========================== -->
          <!-- FINDRISC (ETEL-01) -->
          <!-- ========================== -->
          <v-col
            cols="12"
            md="7"
            v-if="calculator.idCalculator === 'ETEL-01'"
          >
            <v-data-table
              hide-default-footer
              :items="interpretation"
              :headers="headersDiabetesResults"
              class="elevation-1"
            />
          </v-col>

          <v-col
            cols="12"
            md="5"
            v-if="calculator.idCalculator === 'ETEL-01'"
          >
            <v-card outlined>
              <v-card-title class="text-h6">
                Interpretación:
              </v-card-title>
              <v-card-text>
                <div>
                  <p>
                    Puntuación total:
                    <strong>{{ getCalculatorPoints(calculator) }}</strong>
                  </p>
                  <p>
                    Riesgo de desarrollar diabetes en 10 años:
                    <strong>{{ getRiskInterpretation(calculator).riskPercentage }}</strong>
                  </p>
                  <p>
                    Interpretación:
                    <strong>{{ getRiskInterpretation(calculator).riskInterpretation }}</strong>
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- ========================== -->
          <!-- HIPERPLASIA (ETEL-03) -->
          
  <v-col
  cols="12"
  md="12"
  v-if="calculator.idCalculator === 'ETEL-03'"
>
  <v-card outlined>
    <v-card-title class="text-h6">
      Valoración:
    </v-card-title>
    <v-card-text>
      <div>
        <p>
          Puntaje total:
          <strong>{{ getCalculatorPoints(calculator) }}</strong>
        </p>
        <p>
          Sintomatología:
          <strong>{{ getHiperplasiaInterpretation(calculator) }}</strong>
        </p>
      </div>

      <v-row class="mt-3">
        <v-col cols="12">
          <v-simple-table>
            <thead>
              <tr>
                <th>Puntuación total</th>
                <th>Sintomatología</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>De 1 a 7 puntos</td>
                <td class="bg-green">Leve</td>
              </tr>
              <tr>
                <td>De 8 a 19 puntos</td>
                <td class="bg-yellow">Moderada</td>
              </tr>
              <tr>
                <td>Arriba de 20 puntos</td>
                <td class="bg-red">Severa</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</v-col>


          <!-- =========================== -->
          <!-- RIESGO CARDIOVASCULAR (ETEL-02) -->
<v-col
  cols="12"
  md="12"
  v-if="calculator.idCalculator === 'ETEL-02'"
>
      <v-container fluid>
        <v-row align="center" justify="space-around">

          <v-col cols="12" md="6" class="text-center">
            <p class="subtitle-1">Porcentaje de Riesgo Cardiovascular:</p>
            <h1 class="display-1 font-weight-bold">
              {{ getCardioRiskForCalculator(calculator) }}%
            </h1>
          </v-col>

          <v-col cols="12" md="4" class="d-flex justify-center">
            <v-card outlined class="pa-2 compact-risk-table">
              <v-card-title
                class="text-center"
                style="background-color: #008000; color: #fff; font-size: 0.85rem; padding: 4px;"
              >
                Tabla de porcentaje referencial
              </v-card-title>

              <v-simple-table>
                <tbody>
                  <tr>
                    <td class="bg-darkest-red" style="width: 24px;"></td>
                    <td>≥ 50 %</td>
                  </tr>
                  <tr>
                    <td class="bg-dark-red"></td>
                    <td>40 – 49 %</td>
                  </tr>
                  <tr>
                    <td class="bg-red"></td>
                    <td>30 – 39 %</td>
                  </tr>
                  <tr>
                    <td class="bg-orange"></td>
                    <td>20 – 29 %</td>
                  </tr>
                  <tr>
                    <td class="bg-yellow"></td>
                    <td>10 – 19 %</td>
                  </tr>
                  <tr>
                    <td class="bg-light-green"></td>
                    <td>5 – 9 %</td>
                  </tr>
                  <tr>
                    <td class="bg-green"></td>
                    <td>&lt; 5 %</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
</v-col>


        </v-row>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>


                    <v-expansion-panels class="my-3" v-model="panelHF" multiple>
                      <v-expansion-panel v-for="(item, index) in heredoFamiliar" :key="index">
                        <v-expansion-panel-header>
                          {{ item.name }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row align="center">
                            <v-col v-for="(question, subindex) in item.questions" :key="subindex">
                              <span>{{ question.name }}</span>
                              <validation-provider v-slot="{ errors }" :name="question.name" :rules="question.required == 1 ? 'required' : ''
      ">
                                <v-radio-group v-if="question.typeAnswer == 2 ||
      question.typeAnswer == 4
      " v-model="question.idAnswer" :disabled="selectedPatient" :error-messages="errors"
                                  :required="question.required == 1">
                                  <v-radio v-for="(answer,
      sub_subindex) in question.answers" :key="sub_subindex" :value="answer.idAnswer"
                                    :label="answer.name" />
                                </v-radio-group>

                                <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                                  :items="question.answers" item-text="name" item-value="idAnswer"
                                  :error-messages="errors" :disabled="selectedPatient" auto-select-first chips clearable
                                  deletable-chips multiple small-chips dense :required="question.required == 1" />

                                <v-text-field v-if="(question.typeAnswer == 1 ||
        question.typeAnswer == 4) &&
      question.typeData != 6
      " v-model="question.answer" :error-messages="errors" :disabled="selectedPatient"
                                  :type="question.typeDataText" :required="question.required == 1" autocomplete="off"
                                  dense clearable />

                                <v-textarea v-if="(question.typeAnswer == 1 ||
        question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" :error-messages="errors" outlined dense clearable
                                  auto-grow />
                              </validation-provider>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels class="mt-3 mb-5" v-model="panelPL" multiple>
                      <v-expansion-panel v-for="(item, index) in pathologicals" :key="index">
                        <v-expansion-panel-header>
                          {{ item.name }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row align="baseline">
                            <v-col v-for="(question, subindex) in item.questions" :key="subindex">
                              <span>{{ question.name }}</span>
                              <validation-provider v-slot="{ errors }" :name="question.name" :rules="question.required == 1 ? 'required' : ''
      ">
                                <v-radio-group v-if="question.typeAnswer == 2 ||
      question.typeAnswer == 4
      " v-model="question.idAnswer" :disabled="selectedPatient" :error-messages="errors"
                                  :required="question.required == 1">
                                  <v-radio v-for="(answer,
      sub_subindex) in question.answers" :key="sub_subindex" :value="answer.idAnswer"
                                    :label="answer.name" />
                                </v-radio-group>

                                <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                                  :items="question.answers" item-text="name" item-value="idAnswer"
                                  :error-messages="errors" auto-select-first chips clearable deletable-chips multiple
                                  :disabled="selectedPatient" small-chips dense :required="question.required == 1" />

                                <v-text-field v-if="(question.typeAnswer == 1 ||
        question.typeAnswer == 4) &&
      question.typeData != 6
      " v-model="question.answer" :error-messages="errors" :disabled="selectedPatient"
                                  :type="question.typeDataText" :required="question.required == 1" autocomplete="off"
                                  dense clearable />

                                <v-textarea v-if="(question.typeAnswer == 1 ||
        question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" :error-messages="errors" outlined dense clearable
                                  auto-grow />
                              </validation-provider>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-row v-if="genderPatient === 'Femenino'">
  <v-col cols="12" md="4">
    <validation-provider
      name="¿Está embarazada?"
      rules="required"
      v-slot="{ errors }"
    >
      <span>¿Está embarazada? <span class="error--text">*</span></span>
      <v-radio-group
        v-model="isPregnant"
        :error-messages="errors"
        row
      >
        <v-radio label="Sí" value="1" />
        <v-radio label="No" value="0" />
      </v-radio-group>
    </validation-provider>
  </v-col>
</v-row>


<v-expansion-panels
  class="mt-3 mb-5"
  v-model="panelGO"
  v-if="genderPatient === 'Femenino'"
  multiple
>
  <v-expansion-panel
    v-for="(item, index) in ginecologicos"
    :key="index"
  >
    <v-expansion-panel-header>
      {{ item.name }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row align="baseline" dense>
        <v-col
          v-for="(question, subindex) in item.questions"
          :key="subindex"
          cols="12"
          md="4"
          xl="6"
          sm="12"
        >
          <span>{{ question.name }}</span>
          <validation-provider
            :name="question.name"
            :rules="(question.idQuestion === 'C-29' || question.idQuestion === 'C-30') 
            ? (isPregnant === '1' ? 'required' : '') 
            : (question.required == 1 ? 'required' : '')"
            v-slot="{ errors }"
          >
            <v-radio-group
              v-if="question.typeAnswer == 2 || question.typeAnswer == 4"
              v-model="question.idAnswer"
              :error-messages="errors"
              :required="question.required == 1"
            >
              <v-radio
                v-for="(answer, iAns) in question.answers"
                :key="iAns"
                :value="answer.idAnswer"
                :label="answer.name"
              />
            </v-radio-group>

            <v-autocomplete
              v-else-if="question.typeAnswer == 3"
              v-model="question.selectedAnswers"
              :items="question.answers"
              item-text="name"
              item-value="idAnswer"
              :error-messages="errors"
              auto-select-first
              chips
              clearable
              deletable-chips
              multiple
              small-chips
              dense
              :required="question.required == 1"
            />

            <v-text-field
              v-else-if="(question.typeAnswer == 1 || question.typeAnswer == 4) && question.typeData != 6"
              v-model="question.answer"
              :error-messages="errors"
              :type="question.typeDataText"
              :required="question.required == 1"
              autocomplete="off"
              clearable
              dense
              :counter="20"
              :maxlength="20"

              :disabled="(question.idQuestion === 'C-29' || question.idQuestion === 'C-30') && isPregnant === '0'"

            />

            <v-textarea
              v-else-if="(question.typeAnswer == 1 || question.typeAnswer == 4) && question.typeData == 6"
              v-model="question.answer"
              :error-messages="errors"
              outlined
              dense
              clearable
              auto-grow
              :disabled="
                (question.idQuestion === 'C-29' || question.idQuestion === 'C-30')
                && isPregnant === '0'
              "
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row 
  class="mt-5"       
  align="center"     
  justify="start"    
  dense
>
  <v-col cols="12" md="4">
    <validation-provider v-slot="{ errors }" name="¿Tiene alguna discapacidad?" rules="required">
      <v-radio-group
        v-model="patient.hasDisability"
        label="¿Tiene alguna discapacidad?"
        row
        :error-messages="errors"
      >
        <v-radio label="Sí" value="1"></v-radio>
        <v-radio label="No" value="0"></v-radio>
      </v-radio-group>
    </validation-provider>
  </v-col>

  <v-col 
  cols="12" 
  md="4" 
  v-if="patient.hasDisability === '1'"
  class="d-flex align-center"
>
  <div class="d-flex align-center">
    <span class="mr-2 grey--text text--darken-3" style="white-space: nowrap;">
      Seleccione la discapacidad:
    </span>

    <v-select
      v-model="patient.disabilityType"
      :items="disabilityOptions"  
      item-text="text"
      item-value="value"
      label=""
      hide-details="auto"
      clearable
      dense
      class="mt-n2"           
      style="margin-top: -5px;" 
    />
  </div>
</v-col>


</v-row>

                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">Nota médica</h3>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="mb-5" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                    <validation-provider v-slot="{ errors }" name="Nota médica" rules="required">
                      <vue-editor v-model="content" :error-messages="errors"  solo label=""  @input="onEditorInput" required />
                      <span class="error--text">{{ errors.toString() }}</span>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-2">Catálogo CIE10</h3>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Diagnóstico" rules="required">
                      <v-autocomplete v-model="cieSelected" label="Diagnóstico"
                        no-data-text="Sin resultados por mostrar" required dense chips multiple :error-messages="errors"
                        :items="cie" :item-text="cie.text" :item-value="cie.value">
                        <template v-slot:selection="data">
                          <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
                            @click:close="remove(data.item)">
                            {{ data.item.text }}
                          </v-chip>
                        </template>

                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.text"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="8" sm="12" justify="center" class="mb-5" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                    <span>Detalles de diagnóstico</span>
                    <validation-provider v-slot="{ errors }" name="Detalles de diagnóstico" rules="required">
                      <v-textarea v-model="diagnosticDetails" solo label="" value="" :error-messages="errors"
                        :counter="1000" :maxlength="1000" outlined dense clearable auto-grow>
                      </v-textarea>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider v-slot="{ errors, valid }" name="Diagnóstico subsecuente" rules="required">
                      <v-autocomplete label="Diagnóstico subsecuente*" v-model="subsequent"
                        :error-messages="errors" dense no-data-text="Sin resultados disponibles" required
                        :clear-icon="$cnst.CLEAR_ICON" clearable :items="['SI', 'NO']">
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                          {{ valid && subsequent ? " mdi-check" : "" }}
                        </v-icon>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">Agregados</h3>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-btn color="secondary" rounded large @click="
      consulta.receta = true;
    $vuetify.goTo('#consulta');
    " :disabled="consulta.receta === true">
                      Receta médica<v-icon right>mdi-prescription</v-icon>
                    </v-btn>
                  </v-col>

                  <v-col class="text-center">
                    <v-btn color="secondary" rounded large @click="
      consulta.laboratorio = true;
    $vuetify.goTo('#consulta');
    " :disabled="consulta.laboratorio === true">
                      Especialidades<v-icon right>mdi-microscope</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <template>
                  <v-container>
                    <v-card flat>
                      <v-container v-if="consulta.receta == true" class="mt-5">
                        <v-row align="baseline" justify="center">
                          <v-col>
                            <p class="title">Receta médica</p>
                          </v-col>
                          <!-- <v-col> -->
                          <v-col class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn plain icon color="error" v-bind="attrs" v-on="on"
                                  @click="consulta.receta = false">
                                  <v-icon size="30px">mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span>Cerrar</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>

                        <validation-observer v-slot="{ invalid }" ref="fmPres" disabled>
                          <v-form lazy-validation v-model="fmPresValid">
                            <v-row dense>
                              <v-col>
                                <validation-provider v-slot="{ errors }" rules="required" name="Producto">
                                  <v-autocomplete prepend-icon="mdi-medical-bag" v-model="product.idProduct"
                                    :items="productsList" :item-text="productsList.text"
                                    :item-value="productsList.value" :error-messages="errors" label="Producto"
                                    @change="saveQuantity(product)" no-data-text="Sin medicamentos por mostrar"
                                    clearable>
                                    <template v-slot:item="data">
                                      <v-tooltip top color="primary">
                                        <template slot="activator" slot-scope="{ on }">
                                          <v-list-item-content>
                                            <v-list-item-title v-on="on" v-html="data.item.text"></v-list-item-title>
                                          </v-list-item-content>
                                        </template>
                                        <small>{{
      data.item.description
    }}</small>
                                      </v-tooltip>
                                    </template>
                                  </v-autocomplete>
                                </validation-provider>
                              </v-col>

                              <v-col>
                                <validation-provider v-slot="{ errors }" name="Cantidad" :rules="checkStocks">
                                  <v-text-field prepend-icon="mdi-playlist-plus" v-model="product.request" type="number"
                                    label="Cantidad" min="0" :error-messages="errors"></v-text-field>
                                </validation-provider>
                              </v-col>

                              <v-col>
                                <validation-provider v-slot="{ errors }" name="Instrucciones" rules="required|max:500">
                                  <v-textarea prepend-icon="mdi-pencil" v-model="product.instruction"
                                    label="Instrucciones" auto-grow rows="1" :error-messages="errors"
                                    :counter="500"></v-textarea>
                                </validation-provider>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col>
                                <small v-if="$utilFront.isNonNull(quantity)">
                                    Cantidad en stock :{{ quantity }}
                                </small>
                              </v-col>
                            </v-row>

                            <v-row align="center" justify="space-around" class="mb-5 mt-4">
                              <v-btn color="secondary" text @click="resetPresForm()">Limpiar
                                <v-icon right>mdi-eraser</v-icon></v-btn>
                              <v-btn color="primary" @click="addProductPrescription()" :disabled="invalid">
                                Agregar <v-icon right>mdi-plus</v-icon></v-btn>
                            </v-row>
                          </v-form>
                        </validation-observer>
                      </v-container>
                      <v-row>
                        <v-col>
                          <div>
                            <v-container>
                              <v-card v-if="listProductsAdded.length > 0">
                                <v-simple-table dense fixed-header>
                                  <thead>
                                    <tr>
                                      <th>Clave</th>
                                      <th>Producto</th>
                                      <th>Instrucciones</th>
                                      <th>Cantidad</th>
                                      <th>Eliminar</th>
                                    </tr>
                                  </thead>
                                  <tbody v-for="(item, index) in listProductsAdded" :key="index">
                                    <tr>
                                      <td>{{ item.product_key }}</td>
                                      <td>{{ item.name }}</td>
                                      <td>{{ item.instruction }}</td>
                                      <td class="text-center">
                                        {{ item.request }}
                                      </td>
                                      <td>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="error" text dark v-bind="attrs" v-on="on" @click="
      deleteProductAdded(item.value)
      ">
                                              <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Eliminar medicamento
                                            {{ item.text }}</span>
                                        </v-tooltip>
                                      </td>
                                    </tr>
                                  </tbody>
                                </v-simple-table>
                              </v-card>
                            </v-container>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-container>
                </template>

                <template>
                  <v-container>
                    <v-card flat>
                      <v-container v-if="consulta.laboratorio == true" id="laboratorio" class="mt-5">
                        <v-row>
                            <!-- <v-col cols="12" sm="12" md="12">
                              <v-banner color="blue-grey lighten-5"   shaped single-line>
                                Especialidades
                              </v-banner>
                            </v-col> -->
                            
                            <v-row>
                              <v-col>
                                <h3 class="font-weight-black mb-2">Especialidades</h3>
                              </v-col>
                            </v-row>

                          <!-- <v-col class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  plain
                                  icon
                                  color="error"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="consulta.laboratorio = false"
                                >
                                  <v-icon size="30px">mdi-close</v-icon>
                                </v-btn>
                              </template>
<span>Cerrar</span>
</v-tooltip>
</v-col> -->
                        </v-row>
                        <v-row v-if="patientData && patientData.idPatient" dense>
                            <v-col>
                              <SpecialitiesTabs
  ref="specTabs"
  @addStudies="addStudies"
  @clear-labs="clearLabs"
  @pending-selection="handlePendingSelection"
  :patientData="patientData"
  :medicalPractice="medicalPractice"
/>                            
</v-col>
                        </v-row>
                        <!-- <v-subheader>Información de cita</v-subheader> -->
                        <validation-observer v-slot="{ }" ref="fmEst" disabled>
                          <v-form lazy-validation v-model="fmEstValid">
                            <!-- <v-row class="mb-2">
                              <v-col v-if="$utilFront.nonLite()">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Fecha y hora"
                                >
                                  <VueCtkDateTimePicker
                                    v-model="addLabStudy.startTime"
                                    :no-value-to-custom-elem="true || false"
                                    button-now-translation="Ahora"
                                    :minDate="currentDate"
                                    minute-interval="10"
                                  >
                                    <v-text-field
                                      :value="addLabStudy.startTime"
                                      clearable
                                      prepend-icon="mdi-calendar"
                                      label="Fecha y hora"
                                      no-autocomplete
                                      :rules="nameRules"
                                      :error-messages="errors"
                                      required
                                      @click="swDoctor = false"
                                    ></v-text-field>
                                  </VueCtkDateTimePicker>
                                </validation-provider>
                              </v-col>

                              <v-col md="4">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Especialidad"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    return-object
                                    v-model="addLabStudy.speciality"
                                    :items="specialitiesList"
                                    :item-text="specialitiesList.text"
                                    :item-value="specialitiesList.value"
                                    :error-messages="errors"
                                    clearable
                                    prepend-icon="mdi-hospital"
                                    label="Especialidad"
                                    @change="
                                      listModaltyBySpecialty(
                                        addLabStudy.speciality.value
                                      );
                                      swModalty = false;
                                    "
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>

                              <v-col
                                v-if="
                                  addLabStudy.speciality &&
                                  addLabStudy.speciality.value != 4 &&
                                  addLabStudy.speciality.value != 5 &&
                                  addLabStudy.speciality.value != 6 &&
                                  addLabStudy.speciality.value != 7
                                "
                              >
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Modalidad"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    return-object
                                    v-model="addLabStudy.modalty"
                                    :items="modaltiesList"
                                    :items-text="modaltiesList.text"
                                    :items-value="modaltiesList.value"
                                    :error-messages="errors"
                                    clearable
                                    label="Modalidad"
                                    no-data-text="Sin modalidad por mostrar"
                                    prepend-icon="mdi-radiology-box"
                                    @change="
                                      listStudyProfileByModality(
                                        addLabStudy.modalty.value
                                      );
                                      swProfile = false;
                                    "
                                    :disabled="swModalty"
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>

                              <v-col
                                v-if="
                                  addLabStudy.speciality &&
                                  addLabStudy.speciality.value != 4 &&
                                  addLabStudy.speciality.value != 5 &&
                                  addLabStudy.speciality.value != 6 &&
                                  addLabStudy.speciality.value != 7
                                "
                              >
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Perfil de estudio"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    return-object
                                    v-model="addLabStudy.idStudyModality"
                                    :items="profileStudiesList"
                                    :item-text="profileStudiesList.text"
                                    :item-value="profileStudiesList.value"
                                    :error-messages="errors"
                                    clearable
                                    no-data-text="Sin perfiles de estudio por mostrar"
                                    label="Perfil de estudio"
                                    prepend-icon="mdi-radiology-box-outline"
                                    :disabled="swProfile"
                                    @change="swBranchOffice = false"
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>
                              <v-col v-if="$utilFront.nonLite()">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Turno"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    v-model="addLabStudy.turn"
                                    :items="turnList"
                                    :items-text="turnList.text"
                                    :items-value="turnList.value"
                                    :error-messages="errors"
                                    clearable
                                    prepend-icon="mdi-timer-sand"
                                    label="Turno"
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>
                            </v-row> -->
                            <div v-if="$utilFront.nonLite()">
                              <v-divider></v-divider>
                              <v-subheader>Información de envio</v-subheader>

                              <v-row class="mb-2">
                                <v-col>
                                  <validation-provider v-slot="{ errors }" name="Motivo de envío" rules="required">
                                    <v-autocomplete v-model="addLabStudy.type" :items="reasonsList"
                                      :item-text="reasonsList.text" :item-value="reasonsList.value"
                                      :error-messages="errors" clearable prepend-icon="mdi-help" label="Motivo de envío"
                                      required></v-autocomplete>
                                  </validation-provider>
                                </v-col>

                                <v-col>
                                  <validation-provider v-slot="{ errors }" name="Diagnostico presuntivo"
                                    rules="required">
                                    <v-textarea v-model="addLabStudy.reason" :error-messages="errors" rows="1" auto-grow
                                      prepend-icon="mdi-pencil" label="Diagnostico presuntivo" clearable
                                      required></v-textarea>
                                  </validation-provider>
                                </v-col>
                              </v-row>

                              <v-divider></v-divider>
                              <v-subheader>Información de destino</v-subheader>

                              <v-row>
                                <v-col>
                                  <validation-provider v-slot="{ errors }" name="Clave presupuestal destino"
                                    rules="required">
                                    <v-autocomplete return-object v-model="addLabStudy.branchOfficeDestination
      " :items="branchOfficeList" :items-text="branchOfficeList.text"
                                      :items-value="branchOfficeList.value" :error-messages="errors" clearable
                                      prepend-icon="mdi-hospital-building" label="Clave presupuestal destino" @change="
      listAllConsultingRoomsDestination(
        addLabStudy.branchOfficeDestination
          .value
      );
    swConsultingRoom = false;
    " :disabled="swBranchOffice" required></v-autocomplete>
                                  </validation-provider>
                                </v-col>

                                <v-col>
                                  <validation-provider v-slot="{ errors }" name="Consultorio de destino"
                                    rules="required">
                                    <v-autocomplete return-object v-model="addLabStudy.idConsultingRoomDestination
      " :items="consultingRoomsDestination" :items-text="consultingRoomsDestination.text
      " :items-value="consultingRoomsDestination.value
      " :error-messages="errors" clearable prepend-icon="mdi-hospital-marker"
                                      label="Consultorio de destino" no-data-text="Sin consultorios por mostrar"
                                      @change="swDate = false" :disabled="swConsultingRoom" required></v-autocomplete>
                                  </validation-provider>
                                </v-col>
                                <v-col>
                                  <validation-provider v-slot="{ errors }" name="Doctor de destino" rules="required">
                                    <v-autocomplete return-object v-model="addLabStudy.humanResourceDestination
      " :items="humanResourceList" :item-text="humanResourceList.text"
                                      :item-value="humanResourceList.value" :error-messages="errors" clearable
                                      prepend-icon="mdi-doctor" label="Doctor de destino"
                                      no-data-text="Sin doctores por mostrar" :disabled="swDoctor"
                                      required></v-autocomplete>
                                  </validation-provider>
                                </v-col>
                              </v-row>
                            </div>
                            <!-- <v-row
                              align="center"
                              justify="space-around"
                              class="mb-5"
                            >
                              <v-btn
                                color="secondary"
                                text
                                @click="resetEstForm()"
                              >
                                Limpiar <v-icon right>mdi-eraser</v-icon>
                              </v-btn>

                              <v-btn
                                color="primary"
                                @click="addStudies()"
                                :disabled="invalid"
                              >
                                Agregar<v-icon right>mdi-plus</v-icon>
                              </v-btn>
                            </v-row> -->
                          </v-form>
                        </validation-observer>
                      </v-container>
                      <v-row>
                        <v-col>
                          <div class="mt-5">
                            <v-container>
                              <v-card v-if="addedStudiesList.length > 0">
                                <v-simple-table dense fixed-header>
                                  <v-data-table :headers="headersStudy" :items="addedStudiesList" :items-per-page="-1"
                                    :footer-props="{
      'items-per-page-text':
        'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con el búsqueda"
                                    loading-text="Cargando..." no-data-text="Sin resultados disponibles" dense
                                    hide-default-footer fixed-header height="auto">
                                    <template v-slot:[`item.actions`]="{ index }">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn icon @click="
      addedStudiesList.splice(index, 1)
      ">
                                            <v-icon color="error" v-bind="attrs" v-on="on">
                                              mdi-delete
                                            </v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Remover </span>
                                      </v-tooltip>
                                    </template>
                                  </v-data-table>
                                </v-simple-table>
                              </v-card>
                            </v-container>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-container>
                </template>
              </v-container>
            </v-card-text>

            <v-card-actions id="consulta">
              <v-row align="center" justify="center" class="my-3">
                <v-col class="text-center">
                  <v-btn color="error" plain class="mb-4" @click="changeAction(1)"><v-icon
                      left>mdi-chevron-left</v-icon>Volver
                  </v-btn>
                </v-col>

                <v-col class="text-center">
                  <!-- @click="saveConsultation()" -->
                  <v-btn color="primary" :disabled="sending || invalid || !canFinishConsultation" type="submit">
                    Finalizar Consulta
                    <v-icon right>mdi-content-save</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>

      <!--Cancelar Consulta -->
      <v-dialog v-model="dialog2" persistent max-width="1100">
        <v-card>
          <validation-observer ref="cancelDate" v-slot="{ invalid }">
            <v-card-title class="text-h6 text-center error--text">
              ¿Desea cancelar esta consulta?
            </v-card-title>
            <v-card-text>
              <v-container>
                             
                <v-row justify="space-around">
                 
                 <v-col cols="12" md="12" sm="12">
                   <patient-information :model="dataModal" />
                 </v-col>
               </v-row>
                <v-row>
                  <v-col @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                    <v-form v-model="valid" lazy-validation>
                      <validation-provider v-slot="{ errors }" name="Motivo" rules="required|min:6">
                        <v-textarea outlined v-model="reason" :value="reason" label="Motivo de la cancelación"
                          id="cancellation" :error-messages="errors" required></v-textarea>
                      </validation-provider>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn color="error" plain @click="closeCancel()">
                  <v-icon left>mdi-chevron-left</v-icon> Volver
                </v-btn>
              </v-col>
              <v-col>
                <v-btn :disabled="loader || invalid" color="primary" @click="cancelConsultation()">
                  Cancelar consulta <v-icon right>mdi-calendar-remove</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>

      <!--Ver consultas previas -->
      <v-dialog v-model="showEventsList" persistent max-width="600px" transition="dialog-top-transition">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Consultas previas
          </v-card-title>
          <v-container>
            <v-row>
              <v-col>
                <v-card-text>
                  <v-autocomplete v-model="modelClinicalEvent" no-data-text="Sin resultados" :items="eventList"
                    @change="disabledButtonPDF" label="Seleccionar consulta" clearable return-object
                    append-outer-icon="mdi-account-search" />
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" text @click="showEventsList = false">
                volver <v-icon right>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn class="error" @click="exportMedicalToPdf(modelClinicalEvent)" :disabled="buttonPdf || sending">
                Descargar PDF <v-icon right> mdi-file-pdf-box </v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog para descarga de reportes -->
      <v-dialog v-model="reportDialog" persistent max-width="300px" transition="dialog-top-transition">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Visualización de reportes
          </v-card-title>
          <v-container>
            <v-row style="padding: 10px">
              <v-col sm="12" xl="12" md="12">
                <v-btn width="100%" outlined color="error" @click="exportToPdf(2)" :disabled="sending">
                  Nota médica
                  <v-icon right> mdi-file-pdf-box </v-icon>
                </v-btn>
              </v-col>
              <v-col sm="12" xl="12" md="12">
                <v-btn width="100%" outlined color="error" @click="exportToPdf(1)" :disabled="sending || orderStudy">
                  Orden de estudio
                  <v-icon right> mdi-file-pdf-box </v-icon>
                </v-btn>
              </v-col>
              <v-col sm="12" xl="12" md="12">
                <v-btn width="100%" outlined color="error" @click="exportPDF()"
                  :disabled="sending || listProductsAdded.length < 1">
                  Receta médica
                  <v-icon right> mdi-file-pdf-box </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" text @click="showMedicalPracticeList()">
                Salir <v-icon right>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogStudy" max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea registrar la cita para el estudio?
          </v-card-title>
          <v-card-text>
            <p>
              Verifique que haya ingresado la información correcta, ya que una
              vez registrado no se podra modificar
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogStudy = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="
      dialogStudy = false;
    addStudies();
    ">
              Crear cita
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import {
  MedicalPracticeRequest,
  PersonalTypeRequest,
  VitalSignRequest,
  ProductsRequest,
  TypeVitalSignRequest,
  PrescriptionRequest,
  ConsultingRoomRequest,
  BranchOfficeRequest,
  HumanResourceRequest,
  EnumRequest,
  ModaltyRequest,
  StudyModalityRequest,
  StudyRequest,
  CieRequest,
  EvaluationRequest,
  SpecialityRequest,
  ReportPDFRequest,
  CalculatorsSomatometryRequest,
} from "@/core/request";
import Sidebar from "@/components/Sidebar.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Datatable from "@/components/Datatable.vue";
import BtnAccion from "@/components/btnAccion.vue";
import moment from "moment";
import { mapActions } from "vuex";
import Loader from "../../components/Loader.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { VueEditor } from "vue2-editor";

import SpecialitiesTabs from "@/components/appointments/speciality/SpecialitiesTabs.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
import cardioRiskData from "@/app/json/cardioRiskData.json"; 

export default {
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    Loader,
    AutoLogout,
    BranchOfficesList,
    ValidationObserver,
    ValidationProvider,
    Encabezado,
    VueEditor,
    SpecialitiesTabs,
    PatientInformation,
    PatientConsultationInfo,
  },
  name: "Consultas",
  data: () => ({
    fmPresValid: true,
    fmEstValid: true,
    range: "",
    encabezado: { icono: "mdi-stethoscope", texto: "Consultas pendientes" },
    titleAttend: { icono: "mdi-stethoscope", texto: "Atender consulta" },
    listConsPend: [],
    search: "",
    headers: [
    // { text: "#", value: "counter", align: "center" },
      { text: "Id Consulta", value: "idConsulta", align: "center" },
      { text: "Id Paciente", value: "idPatient", align: "center" },
      {
        text: "Nombre del paciente",
        value: "fullNamePatient",
        align: "center",
      },
      {
        text: "Fecha y hora de solicitud",
        value: "fechaCita",
        align: "center",
      },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    btnHisCons: {
      route: "/consultas/historial",
      icon: "mdi-history",
      text: "Historial de consultas",
      tooltip: "Ver historial de consultas",
    },
    dataConsulty: [],
    loader: false,
    branchOffice: null,
    dialog2: false,
    dataModal: {},
    reason: "",
    valid: false,
    reasonRules: [(v) => !!v || "El motivo de la cancelación es obligatorio"],
    consultationCancel: {},
    idBranchOfficeSelected: null,
    cols: "col-md-3 col-xl-3 col-sm-12",
    action: 1,
    // ! DATA ATTEND CONSULTATION
    invalidPrescription: false,
    panelSV: 0,
    antecedents: [],
    headersStudy: [
      { text: "Especialidad", value: "speciality.text" },
      { text: "Modalidad", value: "modalty.text" },
      { text: "Perfil de estudio", value: "idStudyModality.text" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    idPerson: "",
    fab: false,
    fmPres: true,
    nameRules: [(v) => !!v || "Campo requerido"],
    panelDis: true,
    vitalSign: [],
    countLab: 0,
    countImg: 0,
    dialogStudy: false,
    swModalty: true,
    swProfile: true,
    swBranchOffice: true,
    swConsultingRoom: true,
    swDate: true,
    swDoctor: true,
    nameRoute: "ConsultasPendientes",
    paramsRoute: {},
    disabledHeader: true,
    panel: [0],
    dataPatient: {
      appointment: {
        clinicalEvent: {
          patient: {
            person: {},
          },
        },
        consultingRoomDestination: {},
        humanResourceOrigin: {
          person: {},
        },
      },
    },
    consulta: {
      laboratorio: false,
      receta: false,
    },
    res: "",
    content: "",
    textTreatment: "",
    inputsVitalSign: [],
    vitalSignList: [],
    productsList: [],
    addedProductList: [],
    product: {},
    listProductsAdded: [],
    panelCalculators: [],
    calculatorsData: [],
    vitalSignLoaded: false,
    interpretation: [
        {
          scoreRange: "Menos de 7",
          risk: "Riesgo bajo",
          description: "1%",
          minValue: 0,
          maxValue: 6,
        },
        {
          scoreRange: "7-11",
          risk: "Riesgo ligeramente elevado",
          description: "4%",
          minValue: 7,
          maxValue: 11,
        },
        {
          scoreRange: "12-14",
          risk: "Riesgo moderado",
          description: "17%",
          minValue: 12,
          maxValue: 14,
        },
        {
          scoreRange: "15-20",
          risk: "Riesgo alto",
          description: "33%",
          minValue: 15,
          maxValue: 20,
        },
        {
          scoreRange: "Más de 20",
          risk: "Riesgo muy alto",
          description: "50%",
          minValue: 21,
          maxValue: 99,
        },
      ],
      headersDiabetesResults: [
        {
          text: "Puntuación total",
          align: "start",
          value: "scoreRange",
        },
        {
          text: "Riesgo de desarrollar diabetes en los próximos 10 años",
          value: "description",
        },
        { text: "Interpretación", value: "risk" },
      ],
      pointsMapping: {
      "ATEL-03": 0,
  "ATEL-04": 2,
  "ATEL-05": 0,
  "ATEL-06": 1,
  "ATEL-07": 2,
  "ATEL-08": 0,
  "ATEL-09": 5,
  "ATEL-10": 0,
  "ATEL-11": 0,
  "ATEL-12": 3,
  "ATEL-13": 5,
  // HIPERPLASIA PROSTATICA mapping
  "ATEL-14": 0,
  "ATEL-15": 1,
  "ATEL-16": 2,
  "ATEL-17": 3,
  "ATEL-18": 4,
  "ATEL-19": 5,
  "ATEL-20": 0,
  "ATEL-21": 1,
  "ATEL-22": 2,
  "ATEL-23": 3,
  "ATEL-24": 4,
  "ATEL-25": 5,
  "ATEL-26": 0,
  "ATEL-27": 1,
  "ATEL-28": 2,
  "ATEL-29": 3,
  "ATEL-30": 4,
  "ATEL-31": 5,
  "ATEL-32": 0,
  "ATEL-33": 1,
  "ATEL-34": 2,
  "ATEL-35": 3,
  "ATEL-36": 4,
  "ATEL-37": 5,
  "ATEL-38": 0,
  "ATEL-39": 1,
  "ATEL-40": 2,
  "ATEL-41": 3,
  "ATEL-42": 4,
  "ATEL-43": 5,
  "ATEL-44": 0,
  "ATEL-45": 1,
  "ATEL-46": 2,
  "ATEL-47": 3,
  "ATEL-48": 4,
  "ATEL-49": 5,
  "ATEL-50": 0,
  "ATEL-51": 1,
  "ATEL-52": 2,
  "ATEL-53": 3,
  "ATEL-54": 4,
  "ATEL-55": 5
    },
      interpretationRanges: [
        { min: 0, max: 6, risk: "1%", interpretation: "Riesgo bajo" },
        {
          min: 7,
          max: 11,
          risk: "4%",
          interpretation: "Riesgo ligeramente elevado",
        },
        { min: 12, max: 14, risk: "17%", interpretation: "Riesgo moderado" },
        { min: 15, max: 20, risk: "33%", interpretation: "Riesgo alto" },
        {
          min: 21,
          max: Infinity,
          risk: "50%",
          interpretation: "Riesgo muy alto",
        },
      ],
    vitalSign: [],
     isPregnant: null,
    specialitiesList: [
      { text: "Imagen", value: 2 },
      { text: "Laboratorio", value: 3 },
      { text: "Dental", value: 4 },
    ],
    prioritiesList: [],
    addLabStudy: [],
    turnList: [
      { text: "Matutino", value: 1 },
      { text: "Vespertino", value: 2 },
      { text: "Nocturno", value: 3 },
      { text: "Mixto", value: 4 },
    ],
    branchOfficeList: [],
    consultingRoomsOrigin: [],
    consultingRoomsDestination: [],
    modaltiesList: [],
    reasonsList: [],
    disponibility: [],
    profileStudiesList: [],
    humanResourceList: [],
    addedStudiesList: [],
    genderPatient: "",
    old: "",
    birthDate: "",
    eventList: [],
    listTurns: [],
    noMoreAppointments: true,
    showEventsList: false,
    sending: true,
    cie: [],
    cieSelected: [],
    idPerson: "",
    antecedent: {
      livingPlace: {
        typeLivingPlace: {},
        publicServices: [],
        buildMaterial: [],
        rooms: {},
      },
      hygiene: {
        showerTimes: {},
        brushTeeth: {},
        handWashing: {},
      },
      diet: {
        food: {},
        foodTime: {},
        typeFood: [],
      },
    },
    pathologicals: [],
    heredoFamiliar: [],
    ginecologicos: [],
    panelHF: [0],
    panelGO: [0],
    panelPL: [0],
    selectedPatient: true,
    loader: false,
    heredofamiliar: undefined,
    disabilityOptions: [],
      patient: {
        hasDisability: null,   
        disabilityType: null,  
      },
    oldValidation: 0,
    modelClinicalEvent: null,
    buttonPdf: true,
    reportDialog: false,
    reportObject: {},
    diagnosticDetails: "",
    quantity: 0,
    orderStudy: false,
    hasPendingSelection: false,
    /************************** */
    /** @MaudePallares **/
    patientData: {},
    infoPatient: {},
    flagComponentInfo: false,
    subsequent: null
  }),
  created() {
    this.validBrowserTab();
    this.listAllConsultPending();
    // this.getProducts();
    // this.listPriority();
    // this.listAllReasons();
    // this.listAllBranchOffice();
    // this.getCieCatalogue();
    // this.getSpecialities();
  },
  
  computed: {
  filteredCalculators() {
    return this.calculatorsData.filter((calculator) => {
      if (calculator.idCalculator === "ETEL-02" && this.oldValidation < 44) {
        return false;
      }

      if (
        calculator.idCalculator === "ETEL-03" &&
        (this.genderPatient === "Femenino" || this.oldValidation < 40)
      ) {
        return false;
      }

      return true;
    });
  }
}, 
computed: {
  filteredCalculators() {
    return this.calculatorsData.filter((calculator) => {
      if (calculator.idCalculator === "ETEL-02" && this.oldValidation < 44) {
        return false;
      }

      if (
        calculator.idCalculator === "ETEL-03" &&
        (this.genderPatient === "Femenino" || this.oldValidation < 40)
      ) {
        return false;
      }

      return true;
    });
  },
    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${moment(new Date(this.range.start)).format(
        "DD/MM/YYYY"
      )} al ${moment(new Date(this.range.end)).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }

      this.listConsultByDate();
      return true;
    },
    checkStocks() {
      return `required|numeric|min_value:1|max_value:${this.quantity}`;
    },
    agePoints() {
    if (this.oldValidation < 45) {
      return 0;
    } else if (this.oldValidation <= 54) {
      return 2;
    } else if (this.oldValidation <= 64) {
      return 3;
    } else {
      return 4;
    }
  },
  
  imcPoints() {
    const imc = this.findVitalSignValue(3); 
    if (imc < 25) return 0;
    else if (imc < 30) return 1;
    else return 3;
  },

  abdominalPoints() {
    const measure = this.findVitalSignValue(11);
    if (this.genderPatient === "Masculino") {
      if (measure < 94) return 0; 
      if (measure <= 102) return 3;
      return 4;
    } else if (this.genderPatient === "Femenino") {
      if (measure < 80) return 0;
      if (measure <= 88) return 3;
      return 4;
    }
    return 0;
  },

  totalPoints() {
    const questionPoints = this.filteredCalculators[0].dataQuestions.reduce(
      (sum, question) => {
        const selectedAnswer = question.answerClosed; 
        const points = this.pointsMapping[selectedAnswer] || 0; 
        return sum + points;
      },
      0
    );

    return questionPoints + this.agePoints + this.imcPoints + this.abdominalPoints;
  },

  riskData() {
    return this.interpretationRanges.find(
      (range) => this.totalPoints >= range.min && this.totalPoints <= range.max
    );
  },
  riskPercentage() {
    return this.riskData ? this.riskData.risk : "N/A";
  },
  riskInterpretation() {
    return this.riskData ? this.riskData.interpretation : "N/A";
  },

  hasIncompleteStudies() {
    if (!Array.isArray(this.addLabStudy) || this.addLabStudy.length === 0) {
      return false;
    }
    return this.addLabStudy.some(study => {
      const idSpec = study.speciality?.idSpeciality;
      const hasSpec = !!idSpec;
      if (!hasSpec) return true;

      const isLabOrImg = [2, 3].includes(idSpec);
      if (isLabOrImg) {
        const hasMod = !!study.modality?.idModality;
        const hasProf = !!study.studyProfile?.idStudyProfile;
        return !(hasMod && hasProf);
      }

      return false;
    });
  },

  hasIncompleteCalculators() {
    return this.filteredCalculators.some(calc =>
      calc.dataQuestions.some(q => {
        if (q.typeAnswer === 2)    return !q.answerClosed;
        if (q.typeAnswer === 1)    return !q.answerOpen;
        return false;
      })
    );
  },

  canFinishConsultation() {
    return (
      !this.hasIncompleteStudies &&
      !this.hasIncompleteCalculators
    );
  },

  studyValidationMessage() {
    if (!this.hasIncompleteStudies) return '';
    const cnt = this.addLabStudy.filter(study => {
      const idSpec = study.speciality?.idSpeciality;
      const isLabOrImg = [2, 3].includes(idSpec);
      if (!isLabOrImg) return false;
      const hasMod = !!study.modality?.idModality;
      const hasProf = !!study.studyProfile?.idStudyProfile;
      return !(hasMod && hasProf);
    }).length;
    return `Hay ${cnt} estudio(s) de laboratorio/imagen incompletos. Verifique modalidad y perfil.`;
  }
  },
  watch: {
    content(value) {
      if (value) {
        this.sending = false;
      }
    },
  },
  watch: {
    isPregnant(newVal) {
      if (newVal === "0") {
        this.ginecologicos.forEach((item) => {
          item.questions.forEach((question) => {
            if (question.idQuestion === "C-29" || question.idQuestion === "C-30") {
              question.answer = "";
              question.idAnswer = null;
              question.selectedAnswers = [];
            }
          });
        });
      }
    }
  },
  
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    showAction(action) {
      return this.action == action;
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.content = ''
      } else {
        this.content = html
      }
    },
    checkTypetoAssignValidation(vitalsign) {
      switch (vitalsign.label) {
        case "Temperatura":
          return "required|temp";
        case "Frecuencia Cardíaca":
          return "required|heartRate";
        case "Saturación de oxigeno":
          return "required|satuO";
        case "Circunferencia abdominal":
          return "required|hip";
        case "Frecuencia Respiratoria":
          return "required|breathRate";
        case "Talla":
          return "required|size";
        case "Presión Arterial":
          return "required";
        case "Peso":
          return "required";
        case "IMC":
          return "required";
        case "Estado de peso corporal":
          return "required";
      }
    },
    changeAction(action) {
      if (action === 1) {
        this.flagComponentInfo = false;
        this.action = action;
        this.content = "";
        this.cieSelected = [];
        this.diagnosticDetails = "";
        this.subsequent = "";
        this.listProductsAdded = [];
        this.addedStudiesList = [];
        this.$refs.form.reset();
        this.resetPresForm();
        this.resetEstForm();
        this.consulta = {
          laboratorio: false,
          receta: false,
        };
      } else if (2) {
        this.loader = false;
        this.action = action;
      }
    },
    validBrowserTab() {
      this.validTab();
    },
    clearCalendar() {
      if (this.$utilFront.nonEmpty(this.range)) {
        this.range = "";
        this.listAllConsultPending();
      } else {
        this.range = "";
      }
    },
    listAllConsultPending() {
      this.loader = true;
      let data = {
        statusAppointment: 7,
        statusAppointmentList: [7],
        statusMedicalPractice: 6,
        statusMedicalPracticeList: [6],
        speciality: 1,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };

      MedicalPracticeRequest.listMedicalPracticeByStatusAndSpeciality(data)

        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.listConsPend = res.data.data.map((list) => {
              //let doctor = `${list.appointment.humanResourceDestination.person.name} ${list.appointment.humanResourceDestination.person.firstLastname} ${list.appointment.humanResourceDestination.person.secondLastname}`;
              //doctor = doctor.replace("null", "").replace("  ", " ");
              let horario = moment(new Date(list.appointmentDate)).format(
                "HH:mm "
              );
              horario =
                horario +
                " a " +
                moment(new Date(list.endAppointmentDate)).format("HH:mm ");
              let sexG;
              if (list.sex === "H") {
                sexG = "Masculino";
              } else if (list.sex === "M") {
                sexG = "Femenino";
              } else if (list.sex === "X") {
                sexG = "No binario";
              }
              return {
                idConsulta: list.idMedicalPractice,
                idPatient: list.idPatient,
                idCita: list.idAppointment,
                fullNamePatient: list.fullNamePatient,
                doctor: list.fullNameDoctor,
                horario: horario,
                fechaCita: this.$utilFront.formatDateTime(list.appointmentDate),
                nss: list.nss,
                curp: list.curp,
                birthDate: this.$utilFront.formatDate(list.birthDate),
                // sex: list.sex == "M" ? "Femenino" : "Masculino",
                sex: sexG,
                speciality: list.speciality,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    listConsultByDate() {
      this.loader = true;
      let data = {
        statusAppointment: 7,
        statusAppointmentList: [7],
        statusMedicalPractice: 6,
        statusMedicalPracticeList: [6],
        speciality: 1,
        idBranchOffice: this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected : this.$utilFront.getIdBranchOffice()
      };

      if (this.$utilFront.nonEmpty(this.range)) {           
        data.startDate = this.$utilFront.startOfDay(this.range.start);           
        data.finishDate = this.$utilFront.endOfDay(this.range.end);         
      }

      MedicalPracticeRequest.listMedicalPracticeByStatusAndSpeciality(data)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.listConsPend = res.data.data.map((list) => {
              //let doctor = `${list.appointment.humanResourceDestination.person.name} ${list.appointment.humanResourceDestination.person.firstLastname} ${list.appointment.humanResourceDestination.person.secondLastname}`;
              //doctor = doctor.replace("null", "").replace("  ", " ");
              let horario = moment(new Date(list.appointmentDate)).format(
                "hh:mm a"
              );
              horario =
                horario +
                " a " +
                moment(new Date(list.endAppointmentDate)).format("hh:mm a");

              return {
                idConsulta: list.idMedicalPractice,
                idPatient: list.idPatient,
                idCita: list.idAppointment,
                fullNamePatient: list.fullNamePatient,
                doctor: list.fullNameDoctor,
                horario: horario,
                fechaCita: this.$utilFront.formatDateTime(list.appointmentDate),
                nss: list.nss,
                curp: list.curp,
                birthDate: moment(list.birthDate)
                  .locale("es-mx")
                  .format("LL"),
                sex: list.sex,
                speciality: list.speciality,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getConsulty(item) {
      this.$router.push({
        name: "AtenderConsulta",
        params: { id: item.idConsulta },
      });
    },
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      if (this.$utilFront.isNonNull(this.dataModal)) {
        this.dialog2 = true;
      }
    },
    closeCancel() {
      this.reason = "";
      this.$refs.cancelDate.reset();
      this.dialog2 = false;
    },
    cancelConsultation() {
      if (!this.loader) {
        if (this.$refs.cancelDate.validate()) {
          this.loader = true;
          let postID = {
            reason: this.reason,
            medicalPractice: {
              idMedicalPractice: this.dataModal.idConsulta,
            },
            type: 1,
          };
          MedicalPracticeRequest.cancelMedicalPractice(postID)
            .then((res) => {
              if (res.data.data) {
                if (res.data.code === 200 && res.data.status === "OK") {
                  /*for (let i = 0; i < this.list.length; i++) {
                  if (this.list[i].idStudy == this.dataModal.idStudy) {
                    this.list.splice(i, 1);
                  }
                }*/
                  this.$utilFront.notifications(
                    "Estudio cancelado correctamente",
                    "SUCCESS"
                  );
                } else if (res.data.code === 401) {
                  this.unauthorized();
                } else {
                  this.$utilFront.notifications(
                    "Sucedio un error al cancelar el estudio",
                    "ERROR"
                  );
                }
              }
            })
            .finally(() => {
              this.loader = false;
              this.closeCancel();
              this.listAllConsultPending();
            });
        }
      }
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllConsultPending();
    },

    // ! METHODS ATTEND CONSULTATION
    async saveQuantity(product) {
      this.quantity = null;
      let data = await this.productSelectedList(product);
      this.quantity = data[0].quantity;
    },
    async productSelectedList(products) {
      return this.productsList.filter(
        (product) => product.value === products.idProduct
      );
    },
    remove(item) {
      const index = this.cieSelected.indexOf(item.value);
      if (index >= 0) this.cieSelected.splice(index, 1);
    },
    getSpecialities() {
  this.specialitiesList = [];
  SpecialityRequest.allSpeciality().then((res) => {
    let { data } = res.data;

    if (this.$utilFront.nonEmptyList(data)) {
      this.specialitiesList = data
        .map((obj) => {
          return { text: obj.name, value: obj.idSpeciality };
        })
        .filter((obj) => obj.value !== 1 && obj.value !== 8);
    }
  });
},
handlePendingSelection(pending){
    const hasSomething = !!(
      pending &&
      (
        (pending.especialityAppointment && pending.especialityAppointment.idSpeciality) ||
        pending.modalityAppointment ||
        (pending.studyProfileAppointment && pending.studyProfileAppointment.idStudyModality)
      )
    );
    this.hasPendingSelection = hasSomething;
  },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 400;
    },
    ask() {
      if (this.validate()) {
        this.dialogStudy = true;
      }
    },
    resetEstForm() {
      if (this.consulta.laboratorio == true) {
        this.addLabStudy = [];
        this.$refs.fmEst.reset();
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    resetPresForm() {
      if (this.consulta.receta == true) {
        this.product = {};
        this.quantity = 0;
        this.$refs.fmPres.reset();
      }
    },
    validatePresForm() {
      return this.$refs.fmPres.validate();
    },
    getDataConsulty(idMedPractice) {
  let idMedicalPractice = idMedPractice;
  let params = { idMedicalPractice: idMedicalPractice };
  this.patientData = {};

  MedicalPracticeRequest.listMedicalPracticeById(params)
    .then((res) => {
      if (res.data.code === 200 && res.data.status === "OK") {
        if (res.data.data.appointmentList.length != 0) {
          this.eventList = res.data.data.appointmentList.map((e) => {
            e.registrationDate =
              e.registrationDate != null
                ? moment(new Date(e.registrationDate)).format("DD/MM/YYYY")
                : null;
            return {
              text:
                "Consulta " +
                e.idMedicalPractice +
                " (" +
                e.registrationDate +
                ")",
              value: e.idMedicalPractice,
              idDiagnostic: e.idDiagnostic,
            };
          });
          this.noMoreAppointments = false;
        } else {
          this.noMoreAppointments = true;
        }

        this.flagComponentInfo = true;
        this.dataPatient = res.data.data.medicalInformation;
        this.infoPatient = res.data.data.medicalInformation;

        this.patientData = {
          idPatient: this.dataPatient.idPatient,
          idMedicalPractice: this.dataPatient.idMedicalPractice,
        };

        this.birthDate = moment(this.dataPatient.birthDate)
          .locale("es-mx")
          .format("LL");

        this.old = this.$utilFront.obtainAgeWithLabel(
          this.dataPatient.birthDate
        );

        if (this.dataPatient.gender === "H") {
          this.genderPatient = "Masculino";
        } else if (this.dataPatient.gender === "M") {
          this.genderPatient = "Femenino";
        } else if (this.dataPatient.gender === "X") {
          this.genderPatient = "Binario";
        }
        this.idPerson = this.dataPatient.idPerson;

        this.oldValidation = this.$utilFront.obtainAge(
          this.dataPatient.birthDate
        );
        this.changeValidation(this.oldValidation);

        this.getAntecentsByPerson();
        this.changeAction(2);

        const evaluationTypes = [9, 10, 11]; 
        this.getCalculator({ idPerson: this.idPerson, evaluationTypes, idClinicalEvent: this.dataPatient.idClinicalEvent, });
      } else if (res.data.code === 401) {
        this.unauthorized();
      }
      
    })
    .then(() => {
      this.getVitalSignByPatient();
      this.getProducts();
      this.listPriority();
      this.listAllReasons();
      this.listAllBranchOffice();
      this.getCieCatalogue();
      this.getSpecialities();
      this.getAllDisabilities();
    });
},
    getMedicalPracticeByIdAppointment() {
      let idAppointment = this.$route.params.idAppointment;
      MedicalPracticeRequest.listMedicalPracticeByAppointment({
        idAppointment: idAppointment,
      })
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.dataPatient = res.data.data;
            this.birthDate = moment(this.dataPatient.birthDate)
              .locale("es-mx")
              .format("LL");

            this.oldValidation = this.$utilFront.obtainAge(
              this.dataPatient.birthDate
            );

            this.old = this.$utilFront.obtainAgeWithLabel(
              this.dataPatient.birthDate
            );

            this.idPerson = this.dataPatient.idPerson;
            this.getAntecentsByPerson();
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .then(() => {
          this.getTypeVitalSign();
        });
    },
    showAppointments(number) {
      if (number == 1) {
        this.showEventsList = true;
        //this.noMoreAppointments = true;
      } else {
        this.showEventsList = false;
        //this.noMoreAppointments = false;
      }
    },
    getVitalSignByPatient() {
      VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice({
        idMedicalPractice: this.patientData.idMedicalPractice,
      })
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.inputsVitalSign = res.data.data.map((input) => {
              let type = "";
              if (input.vitalSignType.type === 1) {
                type = "number";
              } else if (input.vitalSignType.type === 2) {
                type = "text";
              }
              let required = 0;
              if (input.vitalSignType.required === 1) {
                required = true;
              } else if (input.vitalSignType.required === 2) {
                required = false;
              }

              return {
                idVitalSignType: input.vitalSignType.idVitalSignType,
                type: type,
                label: input.vitalSignType.name,
                suffix: input.vitalSignType.suffix,
                status: input.vitalSignType.status,
                required: required,
                value: input.description,
                idVitalSigns: input.idVitalSigns,
              };
            });

            this.vitalSign = res.data.data.map((values) => {
              return {
                description: values.description,
                idVitalSigns: values.idVitalSigns,
                idVitalSignType: values.vitalSignType.idVitalSignType,
                typeName: values.vitalSignType.name,
                suffix: values.vitalSignType.suffix,
              };
            });
          } else if (
            res.data.code === 400 &&
            res.data.status === "BAD_REQUEST"
          ) {
            this.getTypeVitalSign();
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .finally(() => {
          this.changeValidation(this.oldValidation);
          this.vitalSignLoaded = true;
        });
    },
   
    getCalculator(payload) {
  CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
    .then((res) => {

      this.calculatorsData = res.data;

      this.calculatorsData.forEach((calculator) => {
        calculator.dataQuestions.forEach((question) => {
          if (question.typeAnswer === 2 && question.idAnswer) {
            question.answerClosed = question.idAnswer; 
          }
        });
      });

    })
    .catch((error) => {
      console.error("Error:", error);
    });
},
    getTypeVitalSign() {
      TypeVitalSignRequest.listAllTypeVitalSign().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.inputsVitalSign = res.data.data.map((input) => {
            let type = "";
            if (input.type === 1) {
              type = "number";
            } else if (input.type === 2) {
              type = "text";
            }
            let required = 0;
            if (input.required === 1) {
              required = true;
            } else if (input.required === 2) {
              required = false;
            }
            return {
              idVitalSignType: input.idVitalSignType,
              type: type,
              label: input.name,
              suffix: input.suffix,
              status: input.status,
              required: required,
              value: input.description,
              idVitalSigns: input.idVitalSigns,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    getProducts() {
      let idBranchOffice = this.$utilFront.getIdBranchOffice();
      ProductsRequest.listAllProductsWiExistence({
        idBranchOffice: idBranchOffice,
      }).then((res) => {
        if (res.data.code === 200) {
          this.productsList = res.data.data.map((product) => {
            const description = `${product.name}, ${product.text}`;
            return {
              text:
                product.product_key + " - " + product.name + " " + product.text,
              value: product.idProduct,
              disabled: false,
              description: product.text,
              name: description,
              quantity: product.quantityInStock,
              product_key: product.product_key,
              request: 0,
              instruction: "",
              productName: product.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    addProductPrescription() {
      if (this.validatePresForm()) {
        this.addedProductList.push(this.product);
        this.productsList.forEach((value, index, array) => {
          if (value.value === this.product.idProduct) {
            value.disabled = true;
            value.request = this.product.request;
            value.instruction = this.product.instruction;
          }
        });
        this.listAddedProducts(this.product.idProduct);
        this.product = {};
        this.resetPresForm();
        this.$refs.fmPres.reset();
        this.quantity = 0;
      }
    },
    listAddedProducts(idProduct) {
      let productSelected = {};
      productSelected = this.productsList.find((prod) => {
        return prod.value === idProduct;
      });
      this.listProductsAdded.push(productSelected);
    },
    deleteProductAdded(idProduct) {
      let i = this.addedProductList.findIndex(
        (index) => index.idProduct === idProduct
      );
      let j = this.listProductsAdded.findIndex((i) => i.value === idProduct);
      this.productsList.forEach((value, index, array) => {
        if (value.value === this.addedProductList[i].idProduct)
          value.disabled = false;
      });
      if (j > -1) this.listProductsAdded.splice(j, 1);
      this.$utilFront.notifications("Producto eliminado correctamente", "INFO");
    },
    attendMedicalPractice() {
      if (this.listProductsAdded.length > 0) {
        this.addPrescription();
      }
      if (this.addedStudiesList.length > 0) {
        this.addLabImgStudy();
      }
    },

    listPriority() {
      EnumRequest.listAllStudyPriority().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.prioritiesList = res.data.data.map((priority) => {
            return {
              text: priority.text,
              value: priority.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllConsultingRoomsOrigin() {
      ConsultingRoomRequest.listAllConsultingRoom({
        branchOffice: {
          idBranchOffice: this.objAddDate.idBranchOfficeOrigin,
        },
      }).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200) {
            this.consultingRoomsOrigin = res.data.data.map((room) => {
              return {
                text: room.name,
                value: room.idConsultingRoom,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }
      });
    },
    listAllConsultingRoomsDestination() {
      ConsultingRoomRequest.listAllConsultingRoom({
        branchOffice: {
          idBranchOffice: this.objAddDate.idBranchOfficeDestination,
        },
      }).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200) {
            this.consultingRoomsDestination = res.data.data.map((room) => {
              return {
                text: room.name,
                value: room.idConsultingRoom,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }
      });
    },
    listAllReasons() {
      EnumRequest.listAllAppointmentType().then((res) => {
        if (res.data.data) {
          if (res.data.code === 200) {
            this.reasonsList = res.data.data.map((reason) => {
              return {
                text: reason.text,
                value: reason.value,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }
      });
    },
    listModaltyBySpecialty(idSpeciality) {
      this.addLabStudy.modalty = null;
      this.addLabStudy.idStudyModality = null;
      this.modaltiesList = [];
      this.profileStudiesList = [];

      ModaltyRequest.listModaltyBySpecialty({
        speciality: { idSpeciality: idSpeciality },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.modaltiesList = res.data.data.map((modalty) => {
            let acronym = "";
            if (this.$utilFront.nonEmpty(modalty.acronym)) {
              acronym = `${modalty.acronym} -`;
            }
            let nameProfile = `${acronym} ${modalty.name}`;
            return {
              text: nameProfile,
              value: modalty.idModality,
            };
          });
        } else if (res.data.code === 400) {
          this.modaltiesList = [];
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllBranchOffice() {
      BranchOfficeRequest.listAllBranchOffice().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.branchOfficeList = res.data.data.map((branch) => {
            let branchOffName =
              branch.name + " " + "(" + branch.idBranchOffice + ")";
            return {
              text: branchOffName,
              value: branch.idBranchOffice,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllConsultingRoomsDestination(idBranchOffice) {
      let idModalty = this.addLabStudy.modalty.value;
      let dataPost = {
        idModality: idModalty,
        idBranchOffice: idBranchOffice,
      };
      ConsultingRoomRequest.listAllConsultingRoomByModalty(dataPost).then(
        (res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.consultingRoomsDestination = res.data.data.map(
              (consultingRoom) => {
                return {
                  text: consultingRoom.name,
                  value: consultingRoom.idConsultingRoom,
                };
              }
            );
            this.listAllHumanResources(idBranchOffice);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.consultingRoomsDestination = [];
            this.humanResourceList = [];
          }
        }
      );
    },
    listStudyProfileByModality(idModality) {
      StudyModalityRequest.listStudyModalityByModalty({
        modality: { idModality: idModality },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.profileStudiesList = res.data.data.map((profile) => {
            let acronym = "";
            if (this.$utilFront.nonEmpty(profile.acronym)) {
              acronym = profile.acronym + " - ";
            }
            return {
              text: acronym + "" + profile.name,
              value: profile.idStudyModality,
            };
          });
        } else if (res.data.code === 400) {
          this.profileStudiesList = [];
          this.addLabStudy.idStudyModality = null;
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllHumanResources(idBranch) {
      HumanResourceRequest.listHumanResourcesByType({
        idBranchOffice: idBranch,
      }).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data) {
            this.humanResourceList = res.data.data.map((human) => {
              let fullNameHuman = `${human.person.name} ${human.person.firstLastname} ${human.person.secondLastname} - (${human.personalType.name})`;
              fullNameHuman = fullNameHuman
                .replace("null", "")
                .replace("  ", " ");

              return {
                text: fullNameHuman,
                value: human.idHumanResource,
              };
            });
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          this.humanResourceList = [];
        }
      });
    },
    addPrescription() {
      this.sending = true;
      this.loader = true;
      if (this.addedProductList.length > 0) {
        let arrProducts = [];
        let txtPrescription = "";

        for (const key in this.addedProductList) {
          let obj = {
            request: this.addedProductList[key].request,
            product: {
              idProduct: this.addedProductList[key].idProduct,
            },
          };
          arrProducts.push(obj);
        }

        for (const key in this.listProductsAdded) {
          if (txtPrescription === "") {
            txtPrescription = `${this.listProductsAdded[key].product_key} ${this.listProductsAdded[key].text} - ${this.listProductsAdded[key].instruction}`;
          } else {
            txtPrescription += `|${this.listProductsAdded[key].product_key} ${this.listProductsAdded[key].text} - ${this.listProductsAdded[key].instruction}`;
          }
        }

        let postPrescription = {
          prescription: {
            //textPrescription: txtPrescription,
            diagnostic: {
              textDiagnostic: this.content,
              medicalPractice: {
                idMedicalPractice: this.dataPatient.idMedicalPractice,
              },
              cie10: {
                idCIE10: this.cieSelected,
              },
            },
          },
          products: arrProducts,
        };

        PrescriptionRequest.addPrescription(postPrescription)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Consulta atendida correctamente",
                "SUCCESS"
              );
              this.$router.push("/consultas/pendientes");
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al atender consulta",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      }
    },
    addLabImgStudy() {
      this.sending = true;
      this.loader = true;
      let arrStudies = [];
      let objStudy = {};
      if (this.addedStudiesList.length > 0) {
        for (let key in this.addedStudiesList) {
          let startTime = this.$utilFront.isNonNull(
            this.addedStudiesList[key].startTime
          )
            ? this.addedStudiesList[key].startTime
            : new Date();
          let endTime = this.$utilFront.getDateEndConsulting(startTime);

          let consultingRoomDestination = this.addedStudiesList[key]
            .idConsultingRoomDestination;
          consultingRoomDestination = this.$utilFront.isNonNull(
            consultingRoomDestination
          )
            ? consultingRoomDestination.value
            : null;
          let idHumanResourceDestination = this.addedStudiesList[key]
            .humanResourceDestination;
          idHumanResourceDestination = this.$utilFront.isNonNull(
            idHumanResourceDestination
          )
            ? idHumanResourceDestination.value
            : null;

          objStudy = {
            idBranchOffice: this.$utilFront.getIdBranchOffice(),
            priorityStudy: this.addedStudiesList[key].priorityStudy,
            studyModality: {
              idStudyModality: this.addedStudiesList[key].idStudyModality.value,
            },
            appointment: {
              reason: this.addedStudiesList[key].reason,
              type: this.addedStudiesList[key].type,
              startTime: startTime,
              endTime: endTime,
              turn: this.addedStudiesList[key].turn,
              serviceType: 1,
              speciality: this.addedStudiesList[key].speciality.value,
              clinicalEvent: {
                idClinicalEvent: this.dataPatient.idClinicalEvent,
              },
              consultingRoomOrigin: {
                idConsultingRoom: this.dataPatient.idConsultingRoomDestination,
              },
              consultingRoomDestination: {
                idConsultingRoom: consultingRoomDestination,
              },
              humanResourceOrigin: {
                idHumanResource: this.$utilFront.getIdHumanResource(),
              },
              humanResourceDestination: {
                idHumanResource: idHumanResourceDestination,
              },
            },
          };
          arrStudies.push(objStudy);
        }
        let data = {
          study: arrStudies,
        };
        StudyRequest.addListStudies(data)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Consulta atendida correctamente",
                "SUCCESS"
              );
              this.$router.push("/consultas/pendientes");
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al atender consulta",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      }
    },
    addStudies(list) {
  this.addLabStudy = [...list];
},

    addVitalSigns() {
      const idPatient = this.dataPatient.idPatient;
      let i = 1;
      let objVitalSign = [];
      for (let key in this.vitalSign) {
        let arrVital = {
          description: this.vitalSign[key].description,
          idVitalSigns: this.vitalSign[key].idVitalSigns,
          vitalSignType: {
            idVitalSignType: i,
          },
        };

        objVitalSign.push(arrVital);
        i++;
      }

      const postVitalSign = {
        patient: {
          idPatient: idPatient,
        },
        vitalSigns: objVitalSign,
      };

      VitalSignRequest.addVitalSign(postVitalSign).then((res) => {
        if (res.data.code === 200) {
          this.panelDis = true;
          this.$utilFront.notifications(
            "Signos vitales registrados correctamente",
            "SUCCESS"
          );
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          this.$utilFront.notifications(
            "Error al registrar signos vitales",
            "ERROR"
          );
        }
      });
    },
    calculateIMC() {
      let talla = 0;

      let imc = 0;

      let clasificacion = "";

      if (this.oldValidation >= 18) {
        if (this.vitalSign[0].description) {
          talla = this.vitalSign[0].description / 100;
        }

        if (this.vitalSign[1].description) {
          imc = this.vitalSign[1].description / Math.pow(talla, 2);

          imc = parseFloat(imc).toFixed(2);

          if (imc < 18.5) {
            clasificacion = "Insuficiencia ponderal";
          } else if (imc >= 18 && imc < 25) {
            clasificacion = "Normal";
          } else if (imc >= 25 && imc < 30) {
            clasificacion = "Sobrepeso";
          } else if (imc >= 30 && imc < 35) {
            clasificacion = "Obesidad tipo I";
          } else if (imc >= 35 && imc < 40) {
            clasificacion = "Obesidad tipo II";
          } else if (imc >= 40) {
            clasificacion = "Obesidad tipo III";
          }

          this.vitalSign[2].description = parseFloat(imc).toFixed(2);
          this.vitalSign[7].description = clasificacion;
        }
      }
    },
    changeValidation(old) {
      for (const key in this.inputsVitalSign) {
        if (old < 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = false;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = false;
          }
        } else if (old >= 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = true;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = true;
          }
        }
      }
    },
    getTurns() {
      const idBranchOffice = this.$utilFront.getIdBranchOffice();
      BranchOfficeRequest.listHoursByBranchOffice({ idBranchOffice }).then(
        (res) => {
          if (res.data.code === 200) {
            this.listTurns = res.data.data.listBranchOfficeHours.map(
              (turno) => {
                return {
                  day: turno.day,
                  dayText: turno.dayText,
                  turn: turno.turn,
                  turnText: turno.turnText,
                  startTime: turno.startTime,
                  endTime: turno.endTime,
                };
              }
            );
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }
      );
    },
    getCieCatalogue() {
      CieRequest.listAllCie().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.cie = res.data.data.map((data) => {
            let cieText = `${data.key} - ${data.name}`;
            return {
              value: data.idCIE10,
              text: cieText,
            };
          });
        }
      });
    },
    getAntecedents() {
      this.sending = true;

      this.pathologicals = [];

      EvaluationRequest.listAllByType({ type: 2 })
        .then((res) => {
          let { data, response, message } = res.data;

          if (response) {
            this.pathologicals = data;

            this.panePL = data.map((it, i) => {
              return i;
            });
          } else {
            this.pathologicals = [];
          }
        })
        .finally(() => {
          this.heredoFamiliar = [];

          EvaluationRequest.listAllByType({ type: 3 })
            .then((res) => {
              let { data, response, message } = res.data;

              if (response) {
                this.heredoFamiliar = data;

                this.panelHF = data.map((it, i) => {
                  return i;
                });
              } else {
                this.heredoFamiliar = [];
              }
            })
            .finally(() => {
              this.sending = false;
            });
        });
    },
    getAntecentsByPerson() {
      this.pathologicals = [];
      this.sending = true;

      EvaluationRequest.listByPersonAndType({
        type: 2,
        idPerson: this.idPerson,
      })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.pathologicals = data;
            this.panePL = data.map((it, i) => {
              return i;
            });
          }
        })
        .finally(() => {
          this.heredoFamiliar = [];

          EvaluationRequest.listByPersonAndType({
            type: 3,
            idPerson: this.idPerson,
          })
            .then((res) => {
              let { data, response, message } = res.data;
              if (response) {
                this.heredoFamiliar = data;
                this.panelHF = data.map((it, i) => {
                  return i;
                });
              }
            })
            .finally(() => {
              EvaluationRequest.listByPersonAndType({
                type: 4,
                idPerson: this.idPerson,
              }).then((res) => {
                let { data, response, message } = res.data;

                if (response) {
                  this.ginecologicos = data;

                  this.panelHF = data.map((it, i) => {
                    return i;
                  });
                } else {
                  this.ginecologicos = [];
                }
              });
              this.sending = false;
            });
        });
    },

    saveConsultation() {
  this.$refs.form.validate().then((success) => {
    if (!success) {
      this.$utilFront.notifications(
        "Verifique que los campos requeridos no estén vacíos",
        "ERROR"
      );
      return;
    }
 
    if (this.hasPendingSelection) {
      this.$utilFront.notifications(
        'Agenda la cita o limpia los campos para finalizar la consulta.',
        "ERROR"
      );
      return;
    } 

    
    if (this.consulta.receta) {
      const { idProduct, request, instruction } = this.product;
      if (idProduct || request || instruction) {
        this.$utilFront.notifications(
          'Tienes un medicamento por agregar. Limpia los campos antes de finalizar.',
          "ERROR"
        );
        return;
      }
    }
        
    if (this.consulta.laboratorio) {
      const specTabs = this.$refs.specTabs;
      const formSpec = specTabs?.$refs.formSpec;
      const m = formSpec?.model || {};
      if (m.especialityAppointment?.idSpeciality) {
        this.$utilFront.notifications(
          'Agenda la cita o limpia los campos para finalizar la consulta.',
          'ERROR'
        );
        return;
      }
    }


    if (this.hasIncompleteStudies) {
      this.$utilFront.notifications(this.studyValidationMessage, 'ERROR');
      return;
    }

    if (!this.sending) {
      this.sending = true;
      this.loader = true;


      const idPatient = this.dataPatient.idPatient;
      const objVitalSign = this.vitalSign.map((vital) => ({
        description: vital.description,
        idVitalSigns: vital.idVitalSigns,
        vitalSignType: { idVitalSignType: vital.idVitalSignType },
      }));

      const evaluations = [...this.pathologicals, ...this.heredoFamiliar];
      if (this.$utilFront.nonEmptyList(this.ginecologicos)) {
        evaluations.push(...this.ginecologicos);
      }

      const postPrescription = this.listProductsAdded.map((product) => ({
        request: product.request,
        product: { idProduct: product.value },
        instructions: product.instruction,
      }));

      const study = this.addLabStudy.map((study) => ({
        speciality: study.speciality.idSpeciality,
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
        studyModality: { idStudyModality: study.studyProfile.idStudyProfile },
        appointment: null,
      }));

      const diagnostic = {
        textDiagnostic: this.content,
        diagnosticDetails: this.diagnosticDetails,
        medicalPractice: { idMedicalPractice: this.dataPatient.idMedicalPractice },
        cie10ListInteger: this.cieSelected,
        isPregnant: Number(this.isPregnant),
      };

      const treatment = { treatment: this.textTreatment };

      const calculatorsPayload = {
        calculators: this.calculatorsData.map((calculator) => ({
          idCalculator: calculator.idCalculator,
          score: this.getCalculatorScore(calculator),
          dataQuestions: calculator.dataQuestions
            .filter((q) => q.answerClosed)
            .map((q) => ({
              idQuestion: q.idQuestion,
              idAnswer: q.answerClosed,
            })),
        })),
        idPerson: this.idPerson,
        appointments: null,
        idClinicalEvent: this.dataPatient.idClinicalEvent,
        idBranchOffice: this.$utilFront.getIdBranchOffice()
      };

      const data = {
        idHumanResource: this.$utilFront.getIdHumanResource(),
        idMedicalPractice: this.dataPatient.idMedicalPractice,
        vitalSigns: { patient: { idPatient }, vitalSigns: objVitalSign },
        evaluation: { evaluations, idPerson: this.idPerson, disability: this.patient.hasDisability === '1' ? this.patient.disabilityType : 1 },
        prescription: { prescription: {}, products: postPrescription },
        studies: { study },
        diagnostic,
        treatment,
        subsequent: this.subsequent,
      };

      Promise.all([
        MedicalPracticeRequest.attend(data),
        CalculatorsSomatometryRequest.editCalculatorsSomatometry(calculatorsPayload),
      ])
        .then(([res]) => {
          const { response, message, data } = res.data;
          if (response) {
            this.$utilFront.notifications(
              "Se ha registrado correctamente.",
              "SUCCESS"
            );
            this.reportDialog = true;
            this.reportObject = data;
            this.listAllConsultPending();
          } else {
            throw new Error(message);
          }
        })
        .catch((error) => {
          this.$utilFront.notifications(
            `Error al finalizar la consulta: ${error.message}`,
            "ERROR"
          );
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
          this.$refs.form.reset();
        });
    }
  });
},


    showMedicalPracticeList() {
      (this.reportDialog = false), this.changeAction(1);
      // this.dataPatient = {};
      this.content = "";
      this.cieSelected = [];
      this.diagnosticDetails = "";
      this.listProductsAdded = [];
      this.addedStudiesList = [];
      this.consulta = {
        laboratorio: false,
        receta: false,
      };
      this.$refs.form.reset();
    },
    resetData() {
      this.vitalSignForm = {};
      this.vitalSign = {};
    },

    exportToPdf(type) {
      this.sending = true;

      if (this.dataPatient.idMedicalPractice) {
        const fileName = `Consulta_${this.dataPatient.idMedicalPractice
          }_${moment(new Date(this.dataPatient.startTime)).format("YYYY-MM-DD")}`;

        if (type == 1) {
          const data = {
            idConsultation: this.reportObject.idMedicalPractice,
            idDiagnostic: this.reportObject.idDiagnostic,
            fileName: fileName,
          };
          ReportPDFRequest.downloadOrderStudy(data).then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/pdf",
                })
              );
              window.open(url);
            } else {
              res.data.text().then((txt) => {
                let data = JSON.parse(txt);
                this.$utilFront.notifications(data.data, "ERROR");
              });
            }
          });
        } else if (type == 2) {
          const data = {
            idConsultation: this.reportObject.idMedicalPractice,
            idDiagnostic: this.reportObject.idDiagnostic,
            fileName: fileName,
          };
          ReportPDFRequest.downloadConsultation1(data).then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/pdf",
                })
              );
              window.open(url);
            } else {
              res.data.text().then((txt) => {
                let data = JSON.parse(txt);
                this.$utilFront.notifications(data.data, "ERROR");
              });
            }
          });
        } else if (type == 3) {
          let evaluations = undefined;

          if (this.$utilFront.nonEmptyList(this.ginecologicos)) {
            evaluations = this.pathologicals.concat(
              this.heredoFamiliar,
              this.ginecologicos
            );
          } else {
            evaluations = this.pathologicals.concat(this.heredoFamiliar);
          }

          let evaluation = {
            evaluations: evaluations,
            idPerson: this.idPerson,
          };

          const data = {
            idConsultation: this.reportObject.idMedicalPractice,
            idDiagnostic: this.reportObject.idDiagnostic,
            fileName: fileName,
            evaluation: evaluation,
          };
          ReportPDFRequest.downloadClinicalHistory(data).then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/pdf",
                })
              );
              window.open(url);
            } else {
              res.data.text().then((txt) => {
                let data = JSON.parse(txt);
                this.$utilFront.notifications(data.data, "ERROR");
              });
            }
          });
        }
        this.sending = false;
      }
    },
    exportMedicalToPdf() {
      this.sending = true;
      if (this.modelClinicalEvent) {
        const fileName = `Consulta_${this.modelClinicalEvent.value}`;
        const data = {
          idConsultation: this.modelClinicalEvent.value,
          idDiagnostic: this.modelClinicalEvent.idDiagnostic,
          fileName: fileName,
        };
        ReportPDFRequest.downloadConsultation(data);
        this.sending = false;
      }
    },
    disabledButtonPDF() {
      this.modelClinicalEvent == null
        ? (this.buttonPdf = true)
        : (this.buttonPdf = false);
    },
    exportPDF() {
      if (this.$utilFront.nonEmptyList(this.listProductsAdded)) {
        let arrProducts = [];
        //let txtPrescription = "";
        for (const key in this.listProductsAdded) {
          let obj = {
            request: this.listProductsAdded[key].request,
            products: { idProduct: this.listProductsAdded[key].value },
            instructions: this.listProductsAdded[key].instruction,
          };
          arrProducts.push(obj);
        }
        let url = new URL(location.origin);
        let data = {
          idPrescription: this.reportObject.idPrescription,
          url: url,
          fileName: "Receta",
        };
        this.loader = true;
        ReportPDFRequest.downloadPrescription(data, this);
      }
    },
    getAgePoints() {
    const age = this.oldValidation || 0;
    if (age < 45) {
      return 0;
    } else if (age <= 54) {
      return 2;
    } else if (age <= 64) {
      return 3;
    } else {
      return 4;
    }
  },

  getImcPoints() {
    const imc = parseFloat(this.vitalSign[3]) || 0;
    if (imc < 25) {
      return 0;
    } else if (imc < 30) {
      return 1;
    } else {
      return 3;
    }
  },

  getAbdominalPoints() {
    const measure = this.findVitalSignValue(11);
    const gender = this.genderName || "X";

    if (gender === "Masculino") {
      if (measure < 94) {
        return 0;
      } else if (measure <= 102) {
        return 3;
      } else {
        return 4;
      }
    } else if (gender === "Femenino") {
      if (measure < 80) {
        return 0;
      } else if (measure <= 88) {
        return 3;
      } else {
        return 4;
      }
    } else {
      return 0;
    }
  },

getCalculatorPoints(calculator) {
    const questionPoints = calculator.dataQuestions.reduce((sum, question) => {
      const selectedAnswerId = question.answerClosed;
      const points = this.pointsMapping[selectedAnswerId] || 0;
      return sum + points;
    }, 0);

    let extras = 0;
    
    if (calculator.name === "ESCALA FINDRISC") {
      extras = this.agePoints + this.imcPoints + this.abdominalPoints;
    }
   

    return questionPoints + extras;
  },
  getRiskInterpretation(calculator) {
    const total = this.getCalculatorPoints(calculator);

    const foundRange = this.interpretationRanges.find(
      (range) => total >= range.min && total <= range.max
    );

    if (!foundRange) {
      return {
        riskPercentage: "N/A",
        riskInterpretation: "N/A"
      };
    }

    return {
      riskPercentage: foundRange.risk,
      riskInterpretation: foundRange.interpretation
    };
  },

  getHiperplasiaInterpretation(calculator) {
    const total = this.getCalculatorPoints(calculator);

    if (total >= 1 && total <= 7) {
      return "Leve";
    } else if (total >= 8 && total <= 19) {
      return "Moderada";
    } else if (total >= 20) {
      return "Severa";
    }

    return "N/A";
  },
  getCardioRiskForCalculator(calculator) {
  if (calculator.idCalculator !== "ETEL-02") return 0;

  let isSmoker = false;
  const question = calculator.dataQuestions.find(
    (q) => q.idQuestion === "QTEL-01" 
  );
  if (question && question.answerClosed === "ATEL-01") {
    isSmoker = true;
  }

  let genero = (this.genderPatient  === "Masculino") ? "hombres" : "mujeres";

  const edadRange = this.getAgeRange(this.oldValidation);

  const rawPressure = this.findVitalSignValue(7) || 120; 
  const pKey = this.normalizePressure(rawPressure);

  const rawIMC = this.findVitalSignValue(3) || 20; 
  const imcKey = this.normalizeImc(rawIMC);

  const generoObj = cardioRiskData.datos_generales.find(
    (item) => item.genero === genero
  );
  if (!generoObj) return 0;

  const edadObj = generoObj.datos.find((d) => d.edad === edadRange);
  if (!edadObj) return 0;

  const presionObj = edadObj.presion_arterial.find((pa) => pa.valor === pKey);
  if (!presionObj) return 0;

  const imcObj = presionObj.IMC[imcKey];
  if (!imcObj) return 0;

  const smokeKey = isSmoker ? "fumadoras" : "no_fumadoras";
  const finalValue = imcObj[smokeKey];
  if (finalValue === undefined) return 0;

  return finalValue;
},


    getAgeRange(age) {
      if (age >= 70 && age <= 74) return "70-74";
      if (age >= 65 && age <= 69) return "65-69";
      if (age >= 60 && age <= 64) return "60-64";
      if (age >= 55 && age <= 59) return "55-59";
      if (age >= 50 && age <= 54) return "50-54";
      if (age >= 45 && age <= 49) return "45-49";
      if (age >= 40 && age <= 44) return "40-44";
      return "40-44"; 
    },
    normalizePressure(p) {
      if (p < 130) return 120;
      if (p < 150) return 140;
      if (p < 170) return 160;
      return 180; 
    },
    normalizeImc(imc) {
     
      if (imc < 22) return "20";
      if (imc < 27) return "25";
      if (imc < 32) return "30";
      return "35";
    },
    findVitalSignValue(typeId) {
    const vs = this.vitalSign.find(
      (item) => item.idVitalSignType === typeId
    );
    return vs ? parseFloat(vs.description) || 0 : 0;
  },
  getCalculatorScore(calculator) {

  if (calculator.idCalculator === "ETEL-02") {
    
    return this.getCardioRiskForCalculator(calculator);
  } else {
   
    return this.getCalculatorPoints(calculator);
  }
},
getAllDisabilities() {
  EnumRequest.listAllDisability()
    .then((response) => {
      const { code, status, data } = response.data;
      if (code === 200 && status === "OK") {

        this.disabilityOptions = data.filter(
          (item) => item.value !== 1
        );
      } else {
        this.disabilityOptions = [];
      }
    })
    .catch((error) => {
      console.error("Error cargando discapacidades:", error);
      this.disabilityOptions = [];
    });
},
onPatientLoaded(fullData) {
  this.patient = fullData;
  if (this.patient.person?.disability === null) {
    this.patient.hasDisability = null;
    this.patient.disabilityType = null;
  } else if (this.patient.person?.disability !== 1) {
    this.patient.hasDisability = "1";
    this.patient.disabilityType = this.patient.person.disability;
  } else {
    this.patient.hasDisability = "0";
    this.patient.disabilityType = null;
  }
},

clearLabs() {
  this.$refs.fmEst.reset();
  this.hasPendingSelection = false;
},

  },
};
</script>
<style scoped>
  .bg-light-green {
    background-color: #4caf50; 
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .bg-green {
    background-color: #008000; 
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .bg-light-green {
    background-color: #8BC34A;
    font-weight: bold;
    color: black; 
    text-align: center;
  }
  .bg-yellow {
    background-color: #ffeb3b;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .bg-orange {
    background-color: #ff9800;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .bg-red {
    background-color: #f44336;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .bg-dark-red {
    background-color: #b71c1c;
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .bg-darkest-red {
    background-color: #7f0000; 
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .compact-risk-table {
  max-width: 250px;       
  font-size: 0.85rem;     
}

.compact-risk-table .risk-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.compact-risk-table .risk-percentage {
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.compact-risk-table .v-simple-table thead th,
.compact-risk-table .v-simple-table tbody td {
  padding: 4px 8px !important; 
  font-size: 0.8rem;
}

.color-box {
  width: 18px;
  height: 18px;
}

</style>